import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Select from 'material-ui/Select';
import MenuItem from 'material-ui/Menu/MenuItem';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { InputLabel } from 'material-ui/Input';

import { validateSignup } from '../../utils/validator';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import Loader from '../Parts/Loader';
import * as errMessages from '../../constants/ErrorMessages';
import moment from "moment";

const selectMenuStyles = () => ({
  select: {
    fontSize: '15px',
    minWidth: '240px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '8px 12px',
  },
})

let SelectMenu = withStyles(selectMenuStyles)(props => {
  const {
    label,
    children,
    helperText,
    error,
    ...rest
  } = props;

  return (
    <FormControl fullWidth error={error} style={{ marginTop: '15px' }}>
      <InputLabel
        html-for="plan-selector"
        style={{ fontSize: '13px' }}>
        {label}
      </InputLabel>
      <Select
        inputProps={{
          id: 'plan-selector',
        }}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          }
        }}
        classes={{ select: props.classes.select }}
        fullWidth
        disableUnderline
        {...rest}
      >
        {children}
      </Select>
      <FormHelperText id="plan-selector-helper-text" style={{ margin: helperText ? '8px 0 10px 0' : 0 }}>{helperText}</FormHelperText>
    </FormControl>
  )
});

const double = 2;
const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    padding: '40px',
    boxSizing: 'border-box',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
  },

  form: {
    width: '30%',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit * double,
  },

  bottom: {
    marginTop: '40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },

  title: {
    fontSize: '24px',
    fontWeight: 800,
  },

  button: {
    margin: '26px 0 0 0',
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    fontSize: '15px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  datePicker: {
    width: '100%',
  },

  link: {
    color: '#1A65FF',
    textDecoration: 'none',
  },
});

const NOT_SELECTED = { value: 'NOT_SELECTED', text: '選択してください' };

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      password: '',
      email: '',
      plan_id: NOT_SELECTED.value,
      expirationAt: moment().add(1, 'years'),
      error: {},
    };
  }

  componentDidMount() {
    this.props.postIpCheck();
  }

  componentWillMount() {
    //log out any sessions if is currently logged in
    this.props.signout();

    if ((/keyman-letter/g.test(this.props.pathname))) {
      document.title = 'Keyman Letter';
      this.props.getLetterPlans();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error && nextProps.error !== this.props.error) {
      this.setState({
        error: nextProps.error
      })
    }
  }

  handleChange = property => event => {
    let value = event.target.value;
    this.setState({
      [property]: value,
    });
  };

  changeDate = (date) => {
    const selectedDate = date ? moment(date) : moment().add(1, 'years');
    this.setState({
      expirationAt: selectedDate,
    });
  };

  handleSubmit = () => {
    let { error } = this.state;
    error = this.validateForm();

    const expiration_at = this.state.expirationAt ? this.state.expirationAt.format("YYYY-MM-DD") : null;

    if (Object.keys(error).length === 0) {
      this.props.signup({
        name: this.state.name,
        password: this.state.password,
        email: this.state.email,
        plan_id: null,
        letter_plan_id: this.state.plan_id,
        expiration_at: expiration_at
      });
    }
  }

  validateForm = () => {
    let { error, ...signupInfo } = this.state;
    error = validateSignup(signupInfo);

    if (signupInfo.plan_id === NOT_SELECTED.value) {
      error.plan_id = errMessages.ERR_EMPTY;
    }

    if (/keyman-letter/g.test(this.props.pathname) && !signupInfo.expirationAt) {
      error.expiration_at = errMessages.ERR_EMPTY;
    }

    this.setState({
      error: error,
    });

    return error;
  }

  render() {
    if (this.props.ipCheckLoading) {
      return <div>IPアドレス確認中...</div>;
    }
    if (!this.props.ipCheck) {
      return <div>このページにはアクセスできません。</div>;
    }
    const { classes, letterPlans, isLoading, pathname } = this.props;
    const { error } = this.state;

    const name = 'Keyman Letter';

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography variant="title" className={classes.title}>{name}にサインアップ</Typography>
          <form className={classes.form}>
            <TextField
              id="name"
              label="名前"
              placeholder="名前を入力"
              onChange={this.handleChange('name')}
              error={error.hasOwnProperty('name')}
              helperText={error.name}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              style={{ marginTop: '15px' }}
              fullWidth
            />
            <TextField
              id="email"
              label="メールアドレス"
              placeholder="メールアドレスを入力"
              onChange={this.handleChange('email')}
              error={error.hasOwnProperty('email')}
              helperText={error.email}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              style={{ marginTop: '15px' }}
              fullWidth
            />
            <TextField
              id="password"
              type="password"
              label="パスワード"
              placeholder="パスワードを入力"
              onChange={this.handleChange('password')}
              error={error.hasOwnProperty('password')}
              helperText={error.password}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
              style={{ marginTop: '15px' }}
              fullWidth
            />
            <SelectMenu
              label="プラン"
              value={this.state.plan_id}
              onChange={this.handleChange('plan_id')}
              error={error.hasOwnProperty('plan_id')}
              helperText={error.plan_id}
            >
              <MenuItem value={NOT_SELECTED.value}>{NOT_SELECTED.text}</MenuItem>
              {isLoading ?
                <MenuItem disabled style={{ position: 'relative' }}>
                  <Loader style={{ top: '70%' }} />
                </MenuItem> :
                (letterPlans).map(plan => (
                  <MenuItem key={plan.id} value={plan.id}>
                    {plan.note ?
                      `${plan.name} （${plan.note}）` :
                      plan.name}
                  </MenuItem>
                ))
              }
            </SelectMenu>
            {/keyman-letter/g.test(pathname) && (
              <React.Fragment>
                <Typography variant="body2">有効期限</Typography>
                <div className={`${classes.datePicker} signup-datepicker`}>
                  <DatePicker
                    id="date-picker"
                    locale="ja"
                    dateFormat={"yyyy/MM/dd"}
                    dateFormatCalendar={"yyyy年MM月"}
                    selected={
                      new Date(
                        this.state.expirationAt.format("YYYY-MM-DD")
                      )
                    }
                    onChange={this.changeDate}
                    className={error.hasOwnProperty('expiration_at') ? "signup-datepicker-input-error" : ""}
                    minDate={moment().toDate()}
                  />
                </div>
                {error.hasOwnProperty('expiration_at') && (
                  <FormControl error>
                    <FormHelperText>{error.expiration_at}</FormHelperText>
                  </FormControl>
                )}
              </React.Fragment>
            )}
            <Button
              color="primary"
              fullWidth
              onClick={this.handleSubmit}
              className={classes.button}
            >
              アカウントを作成
            </Button>
          </form>
        </div>
        <div className={classes.bottom}>
          <Typography variant="body2" style={{ color: '#71737B' }}>アカウントを作成することで利用規約に同意したものとみなします。<a className={classes.link} href="http://docs.postoapp.io/contract.html" target="_blank" rel="noreferrer noopener">利用規約</a></Typography>
          <Typography variant="body2" style={{ color: '#71737B' }}>アカウントをお持ちですか？<Link to="/signin" className={classes.link}>サインイン</Link></Typography>
        </div>
      </div>
    );
  }
}

Signup.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  letterPlans: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  getLetterPlans: PropTypes.func.isRequired,
  signup: PropTypes.func.isRequired,
  signout: PropTypes.func.isRequired,
  postIpCheck: PropTypes.func.isRequired,
  ipCheck: PropTypes.bool.isRequired,
  ipCheckLoading: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Signup);



// WEBPACK FOOTER //
// ./src/components/Signup/Signup.jsx